// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-5f93a909]{max-width:100%;max-height:150px;object-fit:contain;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
